import { createContext, useContext, useState, useEffect, useCallback } from 'react';

interface ThemeContextType {
  isDark: boolean;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType>({ isDark: false, toggleTheme: () => {} });

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [isDark, setIsDark] = useState(() => {
    return localStorage.getItem('fenty-theme') === 'dark';
  });

  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.setAttribute('data-theme', 'dark');
      localStorage.setItem('fenty-theme', 'dark');
    } else {
      root.removeAttribute('data-theme');
      localStorage.setItem('fenty-theme', 'light');
    }
  }, [isDark]);

  const toggleTheme = useCallback(() => {
    const root = document.documentElement;
    root.classList.add('dm-transitioning');
    setIsDark(v => !v);
    setTimeout(() => root.classList.remove('dm-transitioning'), 380);
  }, []);

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
